module.exports = __webpack_public_path__ + "static/media/attach.7b4489fe.svg";